import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { GotoQuestionAction } from '../../../../../../models/interactions.model';
import { HighlightVariablesPipe } from '../../../../../../pipes/highlight-variables.pipe';
import { FlowActionCardComponent } from '../flow-action-card/flow-action-card.component';

@Component({
  selector: 'app-flow-goto-question-action',
  imports: [
    FlowActionCardComponent,
    MatIconButton,
    MatIconModule,
    MatTooltip,
    HighlightVariablesPipe,
  ],
  templateUrl: './flow-goto-question-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowGotoQuestionActionComponent {
  readonly data = input.required<GotoQuestionAction>();
  /** Resolved question label for the target question ID. Null if not found. */
  readonly questionLabel = input<string | null>(null);
  readonly panToNode = output<string>();
}
